import { Injectable } from '@angular/core';
import { AnalyticsService } from '@enelx/ngx-shared-services';

type AnalyticsUser = {
  userId?: string;
  user_id?: string;
};

@Injectable()
export class MixPanelService {
  APPLICATION_NAME = 'ASSET_ADMIN';
  PAGE = 'asset_view'
  EVENTS = {
    CLICK_DEEPLINK: 'Click Deeplink',
  };

  private isInit = false;
  private pendingEvents: Array<{ name: string; props: Record<string, unknown> }> = [];

  constructor(private analyticsService: AnalyticsService) {
    addEventListener('user', (event: Event) => {
      const { detail } = event as CustomEvent<{ user?: AnalyticsUser }>;
      this.initialize(detail?.user);
    });
  }

  initialize(user?: AnalyticsUser): void {
    if (this.isInit) return;

    const userId = user?.userId ?? user?.user_id;
    if (!userId) return;

    this.analyticsService.init(userId, this.APPLICATION_NAME);
    this.analyticsService.setPage(this.PAGE);
    this.isInit = true;

    this.pendingEvents.forEach(({ name, props }) => this.analyticsService.pushEvent(name, props));
    this.pendingEvents = [];
  }

  private track(name: string, props: Record<string, unknown> = {}) {
    if (!this.isInit) {
      this.pendingEvents.push({ name, props });
      return;
    }
    this.analyticsService.pushEvent(name, props);
  }

  deepLinkClicked(type: string) {
    this.track(this.EVENTS.CLICK_DEEPLINK, { link_to: type });
  }
}
